import { render, staticRenderFns } from "./SendOrderModal.vue?vue&type=template&id=72e4f45e&"
import script from "./SendOrderModal.vue?vue&type=script&lang=js&"
export * from "./SendOrderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports